module.exports = __webpack_public_path__ + "img/6502.49af17a3.jpg";